import { v4 as uuidv4 } from 'uuid';

import {
  type FormattedMenuItem,
  type MenuItem,
  type TopLevelMenu,
} from 'hb-react/shared/apps/Topics/containers/TopicShowContainer/types';

const getLinkProperties = (menu: MenuItem, currentUrl?: string) => {
  const { url, external, open_in_new_tab: openInNewTab } = menu;

  const isSamePathname =
    currentUrl &&
    url.startsWith(currentUrl) &&
    new URL(url).pathname === window?.location?.pathname;

  const target = external && openInNewTab ? '_blank' : undefined;
  const validExternalURL =
    external &&
    !url.startsWith('/') &&
    currentUrl &&
    !url.startsWith(currentUrl);
  const useDefaultLink = Boolean(validExternalURL || isSamePathname || target);

  return {
    forceDefaultLink: useDefaultLink,
    target,
  };
};

const generateWhiteLabelUrl = (item, getPageUrl) =>
  getPageUrl && !item.external ? getPageUrl(item.url) : item.url;

const prepareItem = (
  item: MenuItem,
  getPageUrl: (path: string) => string,
  currentUrl?: string,
): FormattedMenuItem => {
  const { forceDefaultLink, target } = getLinkProperties(item, currentUrl);

  return {
    forceDefaultLink,
    key: uuidv4(),
    label: item.menu_name,
    path: generateWhiteLabelUrl(item, getPageUrl),
    target,
  };
};

export const formatMenuItems = ({
  items = [],
  getPageUrl,
  currentUrl,
}: {
  currentUrl?: string;
  getPageUrl: (path: string) => string;
  items: Array<TopLevelMenu>;
}): Array<FormattedMenuItem> =>
  items
    .filter(({ menu: { display_in_menu: displayInMenu } }) => displayInMenu)
    .map(({ menu, submenus }) => {
      const subItems = submenus.filter(
        ({ display_in_menu: displayInMenu }) => displayInMenu,
      );

      return {
        ...prepareItem(menu, getPageUrl),
        subItems:
          subItems.length > 0
            ? subItems.map((subItem) =>
                prepareItem(subItem, getPageUrl, currentUrl),
              )
            : undefined,
      };
    });
